<template>
  <div>
    <DownloadChart
      @click="downloadCanvas('decisionChart', 'titleDecisionChart')"
    />
    <div ref="decisionChart" class="p-1">
      <h3 ref="titleDecisionChart" class="hidden mt-4 text-lg">
        Corruption Cases By Decision
      </h3>
      <BarChart
        class="text-white"
        :width="width"
        :height="height"
        :chart-data="chartData"
        :options="options"
      />
      <div v-if="showPercentages" class="mt-8">
        <div class="flex items-center">
          <div class="w-2 h-2 bg-convicted rounded-full mr-3"></div>
          <span class="truncate">Convicted</span>
          <div
            class="h-px flex-1 border border-r border-dashed border-gray-300 mx-3 xl:hidden"
          ></div>
          <span class="font-medium xl:ml-auto">
            {{ ((convicted / totalCases) * 100) | percentage }}
          </span>
        </div>
        <div class="flex items-center mt-3">
          <div class="w-2 h-2 bg-discharged rounded-full mr-3"></div>
          <span class="truncate">Discharged</span>
          <div
            class="h-px flex-1 border border-r border-dashed border-gray-300 mx-3 xl:hidden"
          ></div>
          <span class="font-medium xl:ml-auto">
            {{ ((discharged / totalCases) * 100) | percentage }}
          </span>
        </div>
        <div class="flex items-center mt-3">
          <div class="w-2 h-2 bg-acquitted rounded-full mr-3"></div>
          <span class="truncate">Discharged & acquitted</span>
          <div
            class="h-px flex-1 border border-r border-dashed border-gray-300 mx-3 xl:hidden"
          ></div>
          <span class="font-medium xl:ml-auto">
            {{ ((acquitted / totalCases) * 100) | percentage }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from "./Charts/BarChart";
import axios from "axios";

export default {
  components: {
    BarChart
  },
  props: {
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    },
    showPercentages: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      convicted: 0,
      discharged: 0,
      acquitted: 0,
      totalCases: 0
    };
  },
  computed: {
    // totalCases() {
    //   return this.discharged + this.convicted + this.acquitted;
    // },
    filterParams() {
      return this.$store.state.filtersMenu.selectedFilters;
    },
    chartData() {
      return {
        labels: ["Convicted", "Discharged", "Acquitted"],
        datasets: [
          {
            data: [this.convicted, this.discharged, this.acquitted],
            backgroundColor: ["#951515", "#e27c7c", "#339966"],
            hoverBackgroundColor: ["#951515", "#e27c7c", "#339966"],
            borderWidth: 1,
            borderColor: this.$store.state.main.darkMode ? "#303953" : "#fff",
            pointBackgroundColor: "white",
            pointBorderColor: "#249EBF"
          }
        ]
      };
    },
    options() {
      return {
        legend: {
          display: false
        },
        cutoutPercentage: 80,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: true
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: false
              }
            }
          ]
        },
        tooltips: {
          enabled: true,
          mode: "single",
          callbacks: {
            label: function(tooltipItems) {
              return tooltipItems.yLabel;
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 210
      };
    }
  },
  watch: {
    "$store.state.filtersMenu.count": {
      handler: function() {
        this.run();
      }
    }
  },
  mounted() {
    this.run();
  },
  methods: {
    run() {
      axios
        .get(`${window.host}/api/cases-stages`, {
          params: this.filterParams
        })
        .then(response => {
          if (response.data) {
            this.convicted = response.data.convicted;
            this.discharged = response.data.discharged;
            this.acquitted = response.data.acquitted;
          }
        });

      axios
        .get(`${window.host}/api/cases-count`, {
          params: this.filterParams
        })
        .then(response => {
          if (response.data) {
            this.totalCases = response.data.no_of_cases;
          }
        });
    }
  }
};
</script>

<style scoped>
.bg-convicted {
  background-color: #951515;
}
.bg-discharged {
  background-color: #e27c7c;
}
.bg-acquitted {
  background-color: #339966;
}
</style>
